"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var components_1 = require("./components");
var utils_1 = require("./utils");
function MeiMei(targets, optionalProps) {
    var elements = utils_1.getArrayOfElements(targets);
    components_1.options.setProps(optionalProps);
    var instances = elements &&
        elements.reduce(function (acc, element) {
            var instance = element && new components_1.CreateMeiMei(element);
            if (instance) {
                acc.push(instance);
            }
            return acc;
        }, []);
    return instances;
}
window.MeiMei = MeiMei;
